import React from "react";
import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import moment from "moment";

export default function BStaticDatePicker(props) {
  const onChange = (value) => {
    if (value) {
      props.onChange(moment(value).format("YYYY-MM-DD"));
    }
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <StaticDatePicker
        {...props}
        slotProps={{
          toolbar: { hidden: true },
          actionBar: {
            actions: []
          }
        }}
        value={props.value ? moment(props.value).toDate() : null}
        format="MMM d, y"
        //closeOnSelect
        onChange={onChange}
      />
    </LocalizationProvider>
  );
}
